import { 
    FORCE_IS_ACTIVE_SESSION
    } from '../actions/actionTypes'

export default function reducer(state = {}, action): {}
{
    let input, stateLoc;
    switch (action.type)
    {
        case FORCE_IS_ACTIVE_SESSION:
            stateLoc = action.payload.stateLocation;
            input = action.payload.input;

            return Object.assign({}, state,
            {
                [stateLoc] : input,
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/appevent-welcomeuser-onlaunch/src/reducers/index.ts